import RequestPageTwo from "./RequestPageTwo";

const AnnualExMem = () => {
    return (
        <RequestPageTwo title="Annual Expense Memberships"
            fetchUrl="/get-annual-expense-fund-memberships"
            editEndpoint="update-annual-expense-fund-memberships"
            deleteEndpoint="annual-expense-fund-memberships"
            statusEndpoint="update-annual-expense-fund-memberships" />
    );
}

export default AnnualExMem;
